import { format } from 'date-fns';
import { uk } from 'date-fns/locale/uk';

import { DATE_FORMATS } from './constants';

export class DateUtils {
  static formatForBackend(date: Date): string {
    return format(date, DATE_FORMATS.BACKEND);
  }

  static formatForDisplay(date: Date): string {
    return format(date, DATE_FORMATS.DISPLAY, { locale: uk });
  }

  static isValidDate(date: Date | null): date is Date {
    return date instanceof Date && !isNaN(date.getTime());
  }
}